import { ColorModeContext, useMode } from "./theme";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { Routes, Route, useLocation } from "react-router-dom";
import Topbar from "./scenes/global/Topbar";
import Footer from "./scenes/global/Footer";
import ProteccionUsuario from "./scenes/proteccion";
import BuscarSolicitud from "./scenes/solicitud";
import Dashboard from "./scenes/Home";
import Consultas from "./scenes/consultas";

function App() {
  const [theme, colorMode] = useMode();
  const location = useLocation();

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <div
          className="app"
          style={{
            display: "flex",
            flexDirection: "column",
            minHeight: "100vh",
          }}
        >
          <main
            className="content"
            style={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
            }}
          >
            {/* Obtiene la ruta actual */}
            {location.pathname !== "/" && <Topbar />}

            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/protecUsuario" element={<ProteccionUsuario />} />
              <Route path="/buscarSolicitud" element={<BuscarSolicitud />} />
              <Route path="/consultaUsuario" element={<Consultas />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
}

export default App;
